module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tr-page"
  }, [_vm._m(0), _vm._v(" "), _c('section', {
    staticClass: "tr-table-card"
  }, [_c('div', {
    staticClass: "tr-table-header"
  }, [_c('span', {
    staticClass: "tr-header-icon"
  }, [_c('svg', {
    attrs: {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "1.8",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('path', {
    attrs: {
      "d": "M22 10L12 5 2 10l10 5 10-5z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M6 12v5c0 1.66 2.69 3 6 3s6-1.34 6-3v-5"
    }
  })])]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "tr-table-wrap"
  }, [_c('table', {
    staticClass: "tr-table"
  }, [_vm._m(2), _vm._v(" "), _c('tbody', _vm._l((6), function(n) {
    return _c('tr', {
      key: 'trainer-skeleton-row-' + n
    }, [_vm._m(3, true), _vm._v(" "), _vm._m(4, true), _vm._v(" "), _vm._m(5, true), _vm._v(" "), _vm._m(6, true), _vm._v(" "), _vm._m(7, true)])
  }), 0)])]) : (_vm.trainers.length === 0) ? _c('div', {
    staticClass: "tr-empty"
  }, [_c('span', {
    staticClass: "tr-empty-icon"
  }, [_c('svg', {
    attrs: {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "1.8",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "12",
      "cy": "8",
      "r": "4"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M4 21a8 8 0 0 1 16 0"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M9 15h6"
    }
  })])]), _vm._v(" "), _c('h2', {
    staticClass: "tr-empty-title"
  }, [_vm._v("No trainers found")]), _vm._v(" "), _c('p', {
    staticClass: "tr-empty-text"
  }, [_vm._v("Trainer records will appear here once they are available.")])]) : _c('div', {
    staticClass: "tr-table-wrap"
  }, [_c('table', {
    staticClass: "tr-table"
  }, [_vm._m(8), _vm._v(" "), _c('tbody', _vm._l((_vm.trainers), function(trainer, index) {
    return _c('tr', {
      key: trainer.id || index
    }, [_c('td', [_c('span', {
      staticClass: "tr-id-pill"
    }, [_vm._v(_vm._s(_vm.trainerId(trainer)))])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "tr-name-cell"
    }, [_c('span', {
      staticClass: "tr-avatar",
      attrs: {
        "aria-hidden": "true"
      }
    }, [_vm._v(_vm._s(_vm.trainerInitials(trainer)))]), _vm._v(" "), _c('span', {
      staticClass: "tr-name-text"
    }, [_vm._v(_vm._s(_vm.trainerName(trainer)))])])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.trainerNickname(trainer)))]), _vm._v(" "), _c('td', {
      staticClass: "tr-email-cell"
    }, [_vm._v(_vm._s(_vm.trainerEmail(trainer)))]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "tr-row-actions"
    }, [_c('router-link', {
      staticClass: "tr-action-btn",
      attrs: {
        "to": '/admin/trainers/edit/' + trainer.id,
        "aria-label": 'Edit ' + _vm.trainerName(trainer),
        "title": "Edit trainer"
      }
    }, [_c('svg', {
      attrs: {
        "viewBox": "0 0 24 24",
        "fill": "none",
        "stroke": "currentColor",
        "stroke-width": "1.8",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }
    }, [_c('path', {
      attrs: {
        "d": "M12 20h9"
      }
    }), _vm._v(" "), _c('path', {
      attrs: {
        "d": "M16.5 3.5a2.12 2.12 0 0 1 3 3L7 19l-4 1 1-4 12.5-12.5z"
      }
    })])]), _vm._v(" "), _c('button', {
      staticClass: "tr-action-btn tr-action-btn--danger",
      attrs: {
        "type": "button",
        "disabled": _vm.disabled,
        "aria-label": 'Remove ' + _vm.trainerName(trainer),
        "title": "Remove trainer"
      },
      on: {
        "click": function($event) {
          return _vm.removeTrainer(trainer.id)
        }
      }
    }, [_c('svg', {
      attrs: {
        "viewBox": "0 0 24 24",
        "fill": "none",
        "stroke": "currentColor",
        "stroke-width": "1.8",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }
    }, [_c('path', {
      attrs: {
        "d": "M3 6h18"
      }
    }), _vm._v(" "), _c('path', {
      attrs: {
        "d": "M8 6V4h8v2"
      }
    }), _vm._v(" "), _c('path', {
      attrs: {
        "d": "M19 6l-1 14H6L5 6"
      }
    }), _vm._v(" "), _c('path', {
      attrs: {
        "d": "M10 11v5"
      }
    }), _vm._v(" "), _c('path', {
      attrs: {
        "d": "M14 11v5"
      }
    })])])], 1)])])
  }), 0)])])]), _vm._v(" "), (!_vm.loading && _vm.totalPages > 0) ? _c('div', {
    staticClass: "tr-pagination-footer"
  }, [_c('div', {
    staticClass: "tr-pagination-summary"
  }, [_vm._v("\n      Page " + _vm._s(_vm.currentPage + 1) + " of " + _vm._s(_vm.totalPages) + "\n    ")]), _vm._v(" "), _c('paginate', {
    attrs: {
      "page-count": _vm.totalPages,
      "click-handler": _vm.handlePaginate,
      "prev-text": 'Prev',
      "next-text": 'Next',
      "container-class": 'tr-pagination',
      "page-class": 'tr-pagination-item',
      "page-link-class": 'tr-pagination-link',
      "prev-class": 'tr-pagination-item',
      "prev-link-class": 'tr-pagination-link',
      "next-class": 'tr-pagination-item',
      "next-link-class": 'tr-pagination-link',
      "break-view-class": 'tr-pagination-item',
      "break-view-link-class": 'tr-pagination-link',
      "active-class": 'tr-pagination-active',
      "disabled-class": 'tr-pagination-disabled'
    }
  })], 1) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pg-title-row"
  }, [_c('div', [_c('h1', {
    staticClass: "pg-title"
  }, [_vm._v("Trainers")]), _vm._v(" "), _c('p', {
    staticClass: "pg-title-sub"
  }, [_vm._v("Review, edit and manage trainer account details")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', {
    staticClass: "tr-section-title"
  }, [_vm._v("All Trainers")]), _vm._v(" "), _c('p', {
    staticClass: "tr-section-subtitle"
  }, [_vm._v("Trainer identity and account access list")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("ID")]), _vm._v(" "), _c('th', [_vm._v("Trainer name")]), _vm._v(" "), _c('th', [_vm._v("Nickname")]), _vm._v(" "), _c('th', [_vm._v("E-mail")]), _vm._v(" "), _c('th', {
    staticClass: "tr-actions-col"
  }, [_vm._v("Actions")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('div', {
    staticClass: "tr-sk-id sk-shimmer"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('div', {
    staticClass: "tr-sk-name sk-shimmer"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('div', {
    staticClass: "tr-sk-short sk-shimmer"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('div', {
    staticClass: "tr-sk-email sk-shimmer"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('div', {
    staticClass: "tr-row-actions"
  }, [_c('div', {
    staticClass: "tr-sk-action sk-shimmer"
  }), _vm._v(" "), _c('div', {
    staticClass: "tr-sk-action sk-shimmer"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("ID")]), _vm._v(" "), _c('th', [_vm._v("Trainer name")]), _vm._v(" "), _c('th', [_vm._v("Nickname")]), _vm._v(" "), _c('th', [_vm._v("E-mail")]), _vm._v(" "), _c('th', {
    staticClass: "tr-actions-col"
  }, [_vm._v("Actions")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0152cc73"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LiveRun/Race/TrainerManager/All.vue
// module id = 1645
// module chunks = 2